export default "__VITE_ASSET__VkuPSf5O__"